import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelloWorldComponent } from './hello-world.component';
var NgxElasticlunrModule = /*@__PURE__*/ (function () {
    function NgxElasticlunrModule() {
    }
    NgxElasticlunrModule.forRoot = function () {
        return {
            ngModule: NgxElasticlunrModule
        };
    };
    return NgxElasticlunrModule;
}());
export { NgxElasticlunrModule };
//# sourceMappingURL=ngx-elasticlunr.module.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-elasticlunr/ngx-elasticlunr.module.js
// module id = null
// module chunks = 